import { NotificationCenterRouter } from './NotificationCenterRouter';

export default NotificationCenterRouter;
